import { render, staticRenderFns } from "./GdDetail.vue?vue&type=template&id=6e95f318&scoped=true"
import script from "./GdDetail.vue?vue&type=script&lang=js"
export * from "./GdDetail.vue?vue&type=script&lang=js"
import style0 from "./GdDetail.vue?vue&type=style&index=0&id=6e95f318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e95f318",
  null
  
)

export default component.exports